export interface UserData {
  email: string;
  displayName: string;
  initials: string;
  photoUrl: string;
  authState: AuthStates;
  mpoeApplicationUrl: string;
  bridgeCommanderLink: string;
  permissions: Permissions;
}
interface Permissions {
  canViewAccountPlanOverview: boolean;
  bridgeFull: boolean;
  canViewBridgePaymentSettings: boolean;
  canViewBridgeBasicInformation: boolean;
  canViewBridgeExpandedInformation: boolean;
  canViewEmployeesDashboard: boolean;
  canViewHistoryOfAllEmployees: boolean;
  canUpdateBridgeBasicInformation: boolean;
}
export interface ServerResponse {
  email: string;
  displayName: string;
  initials: string;
  photoUrl: string;
}

export enum AuthStates {
  LOADING = "LOADING",
  ALLOWED = "ALLOWED",
  DENIED = "DENIED",
}
export enum UserDataTypes {
  AUTHENTICATE = "[Auth] AUTHENTICATE",
  AUTH_CHECK = "[Auth] CHECK",
  AUTH_SET = "[Auth] SET",
  AUTH_ERROR = "[Auth] ERROR",
  AUTH_LOGOUT = "[Auth] LOGOUT",
  SET_SYSTEM_ERROR = "[General] SET_SYSTEM_ERROR",
  CLEAR_ERROR_MESSAGE = "[General] CLEAR_ERROR_MESSAGE",
}

export interface UserDataAction {
  readonly type: UserDataTypes;
  readonly payload: any;
}
